import { useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Btn from "../../components/shared/button/Btn"
import KiralikAracContainer from "../../components/ilanlarContainers/KiralikAracContainer"
import { useDispatch } from "react-redux"
import { showModal } from "../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { getAllSaleVehicle, getRentalCar } from "../../features/ilanlar/ilanlarSlice"
import SatilikAraclarContainer from "../../components/ilanlarContainers/SatilikAraclarContainer"
import useWindowDimensions from "../../hooks/useWindowSize"
import SatilikAraclarContainerMobile from "../../components/ilanlarContainers/SatilikAraclarContainerMobile"
import Pagination from "../../components/shared/Pagination"

const Container = styled.div`

width: 100%;
min-height: 100vh;
    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-bottom: 30px;
            }
            .titles {
              width: 100%;
              display: grid;
              grid-template-columns:  1fr 1fr 1fr 1fr 1fr 1fr ;
              padding-inline: 10px;
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
                p{
                  text-align: center;
                }
            }
        }
    }
`
const titles = ["Araç Türü", "Model Yılı", "Km", "Fiyat", "Açıklama", "Fotoğraflar"]

const SatilikAraclar = () => {
  const {theme} = useSelector((state) => state.layout)
  const dispatch = useDispatch()
  const { saleVehicleList, saleVehicleCount } = useSelector((state) => state.ilanlar);
  const {windowDimensions} = useWindowDimensions()

    const [currentPage, setCurrentPage] = useState(1);
  
    const itemsPerPage = 10;
  
    const totalPages = Math.ceil(saleVehicleCount / itemsPerPage);

  useEffect(() => {
    dispatch(getAllSaleVehicle({page: currentPage}))
  }, [currentPage])

  return (
    <Container>
      <PageTopTitle title={"Kiralik Araçlar"} position='sticky'/>
      <div className="wrapper">
        <div className="content">
          <div className="top-container">
            <Btn handleClick={() => dispatch(showModal("addVehiclesForSale"))} color="#E85446" bgColor="transparent" padding="10px" >Araç İlanı Ekle</Btn>
          </div>

          {windowDimensions?.width > 1150 &&
            <div className="titles">
              {titles.map((item) => (
                <p>{item}</p>
              ))}
            </div>
          }

          {windowDimensions?.width > 1150 ? 
            saleVehicleList?.map((item)=>(
              <SatilikAraclarContainer data={item} />
            ))
          :
            saleVehicleList?.map((item)=>(
              <SatilikAraclarContainerMobile data={item} />
            ))
          }

{(saleVehicleList && saleVehicleList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
        </div>
      </div>
    </Container>
  )
}

export default SatilikAraclar